/**************************************************
 * Nombre:       Nosotros_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import foto1 from '../../../Recursos/nosotros1.png'
import foto2 from '../../../Recursos/nosotros2.png'
import foto3 from '../../../Recursos/nosotros3.png'
import {Splide, SplideSlide} from "@splidejs/react-splide";


const Nosotros_Home = () => {
    const navigate = useNavigate();
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 10,
                            border: 4
                        }}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                px: 6,
                                py: !masSM ? 6 : 8,
                                color: '#fff'
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 24 : 32}}>Nosotros</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: sCell ? 16 : 18}}>Quesuditas es una empresa con
                                    trayectoria, organizada en sus procesos y guiada por un fuerte sentido humano que se
                                    refleja en cada detalle.</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Button
                                    onClick={() => navigate('/Nosotros')} color={'secondary'}
                                    sx={{color: theme.palette.primary.main}}>
                                    Ver Más
                                </Button>
                            </Grid>


                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Splide
                                //ref={refe}
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: false,
                                    perMove: 1,
                                    pagination: true,
                                    width: '100%',
                                    drag: 'free',
                                    snap: true,
                                    interval: 3000,
                                    noDrag: true,
                                    focus: 'center',
                                    type: 'fade',

                                }}
                            >

                                {fotos.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qer${index}`}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={12}
                                                sx={{
                                                    backgroundImage: `url(${item})`,
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundSize: 'cover',
                                                    borderBottomRightRadius: 36,
                                                    borderTopRightRadius: sCell ? 0 : 36,
                                                    borderBottomLeftRadius: sCell ? 36 : 0,
                                                    height: sCell ? 250 : 400,
                                                    borderLeft: sCell ? 0 : 4,
                                                    borderColor: '#000'
                                                }}
                                            >


                                            </Grid>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>

                        {/*} <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                backgroundImage: `url(${fondo})`,
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                borderBottomRightRadius: 36,
                                borderTopRightRadius: sCell ? 0 : 36,
                                borderBottomLeftRadius: sCell ? 36 : 0,
                                height: sCell ? 250 : 400,
                                borderLeft: sCell ? 0 : 4,
                                borderColor: '#000'
                            }}
                        >


                        </Grid>*/}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Home

const fotos = [foto1, foto2, foto3]